<!--<ng-container *ngIf="reportList.length == 0 && !isLoading">
<div class="d-flex align-items-center me-5 ms-5">
        <div class="col-md-4 col-sm-12" style="margin-right: 3rem !important;
    margin-left: 2rem;">
    <p class="fs-32">{{ 'MAIN.CONTENT.REPORT-LIST.NO-REPORT.TITLE' | translate }}</p>
    <div class="fs-16-light">{{ 'MAIN.CONTENT.REPORT-LIST.NO-REPORT.TEXT' | translate }}</div>
    <button *ngIf="('electron' | env)" (click)="importReports()" class="v-btn btn btn-primary mt-3 fs-12 font-weight-600 text-white" style="border-radius:7px; height: 30px;padding-top:5px">{{ 'MAIN.CONTENT.REPORT-LIST.IMPORT_REPORTS' | translate }}</button>
  </div>
  <div class="col-md-5 col-sm-12">
    <img src="assets/img/empty.svg" alt="">
  </div>
</div>
</ng-container>-->
<div class="dashboard-wrapper">
  <div class="v-card">
    <div class="card report-header list-header list-header-fixed flex-row justify-content-between align-items-center pe-4 ps-4">
      <div class="d-flex">
        <div class="header fs-20 font-weight-700  pt-1 me-2">{{ 'MAIN.CONTENT.REPORT-LIST.TITLE' | translate }}</div>
        @if (('electron' | env)) {
          <div class="mt-3 ms-3">
            <button (click)="importReports()" class="v-btn btn btn-primary  fs-12 font-weight-600 text-white" style="border-radius:7px; height: 30px;padding-top:5px">{{ 'MAIN.CONTENT.REPORT-LIST.IMPORT_REPORTS' | translate }}</button>
          </div>
        }
      </div>

      @if (!('electron' | env)) {
        <div>
          <button class="v-btn btn btn-primary fs-15 font-weight-600 text-white create-button"
          (click)="export()" [disabled]="isDownloading"> {{ 'MAIN.CONTENT.REPORT.EXPORT' | translate }}</button>
        </div>
      }
    </div>
    <div class="card tab-area d-flex flex-row first-area">
      @if ((isAdmin || hasEditorAccess) && !noWorkflowLicense) {
        <div class="tab-item left fs-16 font-weight-600 ms-4" [ngClass]="{'selected-tab' : tabIndex == 0 }" (click)="onAllReports()">
          <span class="tab-title">{{ 'MAIN.CONTENT.REPORT-LIST.WORKFLOW_REPORTS' | translate }}</span>
        </div>
      }
      @if (isAdmin && !noRemoteLicense) {
        <div class="tab-item right fs-16 font-weight-600 ms-4" [ngClass]="{'selected-tab' : tabIndex == 1 }" (click)="onAllSessions()">
          <span class="tab-title">{{ 'MAIN.CONTENT.REPORT-LIST.REMOTE_SESSIONS' | translate }}</span>
        </div>
      }
    </div>
    @if (tabIndex == 0) {
      <div class="d-flex align-items-center justify-content-between filter-area mb-4 pe-4">
        <div class="d-flex align-items-center ps-3">
          <div class="d-flex" [formGroup]="filterForm">
            <div style="position: relative;">
              <input type="text" placeholder="{{ 'MAIN.CONTENT.REPORT-LIST.PLACEHOLDER' | translate }}" formControlName="nameFilter" class="filter-input fs-14">
              <div class="search-icon"> <img src="assets/img/search.svg" alt=""></div>
            </div>
          </div>
          <div class="d-flex ms-3" [formGroup]="filterForm">
            <div style="position: relative;">
              <input type="text" placeholder="{{ 'MAIN.CONTENT.REPORT-LIST.FILTER-ID' | translate }}"  formControlName="labelFilter" class="filter-input fs-14">
              <div class="search-icon"> <img src="assets/img/search.svg" alt=""></div>
            </div>
          </div>
          <div class="d-flex ms-3">
            <div style="position: relative; margin-right: 10px;">
              <input #filterDates="bsDaterangepicker"
                name="filterDates"
                [(ngModel)]="filterStartEnd"
                class="filter-input fs-14"
                bsDaterangepicker
                placeholder="Search by Date"
                [bsConfig]="{ rangeInputFormat: 'DD-MM-YYYY', containerClass: 'theme-blue', customTodayClass: 'datepicker-today' }"
                (ngModelChange)="onDateRangeChange()"
                [ngModelOptions]="{standalone: true}"
                style="min-width: 220px;">
            </div>
            @if (filterStartEnd?.length > 0) {
              <button
                (click)="clearDateFilters()"
                class="btn btn-sm btn-outline-secondary"
                style="height: 32px; font-size: 12px;"
                title="Clear date filter">
                ✕
              </button>
            }
          </div>
          <div class="d-flex ms-3">
            <div style="position: relative; margin-right: 10px;">
              <ng-select [items]="allUsers"
                name="users"
                bindLabel="name"
                bindValue="id"
                [clearSearchOnAdd]="true"
                [closeOnSelect]="false"
                placeholder="Filter by User"
                [multiple]="true"
                [(ngModel)]="filterUsers"
                (ngModelChange)="onUserFilterChange()"
                [ngModelOptions]="{standalone: true}"
                class="user-filter-select"
                style="min-width: 200px;">
              </ng-select>
            </div>
            @if (filterUsers?.length > 0) {
              <button
                (click)="clearUserFilters()"
                class="btn btn-sm btn-outline-secondary"
                style="height: 32px; font-size: 12px;"
                title="Clear user filter">
                ✕
              </button>
            }
          </div>
        </div>
      </div>
    }

    @if (reportList.length > 0 && !isLoading && tabIndex == 0) {
      <div class="card list-area"  >
            <div class="" style="display: flex;
              text-align: center;
              justify-content: center;">
          <table mat-table [dataSource]="dataSource" matSort matTableResponsive>
            <ng-container matColumnDef="index">
              <th mat-header-cell *matHeaderCellDef>#</th>
              <td mat-cell data-column-name="#" *matCellDef="let i = index">
              </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name" class="col-4 table-fs-14 text-center user-select-none fs-14 text-dark-grey font-weight-400" style="padding-left:20px;">
                {{ 'MAIN.CONTENT.REPORT-LIST.LIST.WORKFLOW' | translate }}
              </th>
                        <td mat-cell [attr.data-column-name]="'MAIN.LOBBY.SESSIONS.DURATION'" *matCellDef="let element" class="d-flex col-4 fs-15 font-weight-700 align-items-center" style="text-align: start;
                        padding-left: 20px;">
                <div>
                  <div>{{element.workflowName}}</div>
                  @if (element?.createdAt) {
                    <div class="description-info fs-12 font-weight-400 mb-0">{{element.createdAt | localizedDate | async}}</div>
                  }
                  @if (element?.['filterValue']) {
                    <div style="margin-top: -3px;" class="mb-1">
                                    <span class="badge badge-secondary pb-1" style="background-color: #eff1f5;
                                    color: #667999;">
                        {{('MAIN.CONTENT.REPORT-LIST.ID-TAG' | translate) }}
                        : {{element['filterValue']}}
                      </span>
                    </div>
                  }
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-1 table-fs-14 text-center fs-12 text-dark-grey font-weight-400">
                Created On
              </th>
              <td mat-cell *matCellDef="let element" class="col-1 fs-11 font-weight-400 d-flex align-items-center justify-content-center">
                @if (element?.createdAt) {
                  <span class="mb-0">{{element.createdAt | localizedDate | async}}</span>
                }
                @if (!element?.createdAt) {
                  <span class="mb-0 text-dark-grey">-</span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="version">
              <th mat-header-cell *matHeaderCellDef class="col-1  table-fs-14 text-center fs-14 text-dark-grey font-weight-400">{{ 'MAIN.CONTENT.REPORT-LIST.LIST.VERSION' | translate }}</th>
              <td mat-cell [attr.data-column-name]="'MAIN.LOBBY.SESSIONS.STATUS'" *matCellDef="let element" class="col-1 fs-14 font-weight-400 d-flex align-items-center justify-content-center">
                v{{element.version}}
              </td>
            </ng-container>
            <ng-container matColumnDef="user">
              <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by user" class="col-1 table-fs-14 text-center fs-14 text-dark-grey font-weight-400">
                {{ 'MAIN.CONTENT.REPORT-LIST.LIST.SUBMITTED-BY' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="col-1 fs-14 font-weight-400 d-flex align-items-center justify-content-center">
                @if (element?.guest?.email) {
                  <p class="font-weight-400 mb-0">{{element.guest.email}}</p>
                }
                @if (!element?.guest?.email && element.userId) {
                  <p class="font-weight-400 mb-0">{{ getUsersName(element.userId) }}</p>
                }
                @if (!element?.guest?.email && !element.userId) {
                  <p class="font-weight-400 mb-0">Unknown User</p>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef class="col-2 table-fs-14 text-center fs-14 text-dark-grey font-weight-400">
                {{ 'MAIN.CONTENT.REPORT-LIST.LIST.APPROVAL' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="col-2 fs-14 d-flex align-items-center justify-content-center">
                @if (element?.signature && element?.signature.signed) {
                  <span class="font-weight-600 mb-0" style="color: #24A148;"> {{ 'MAIN.CONTENT.REPORT-LIST.LIST.APPROVED' | translate }} </span>
                }
                @if (element?.signature && !element?.signature?.signed) {
                  <span class="font-weight-600 mb-0 text-dark-grey">{{ 'MAIN.CONTENT.REPORT-LIST.LIST.PENDING' | translate }} </span>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef class="col-2 table-fs-14 text-center">
              </th>
              <td mat-cell *matCellDef="let element" class="col-2 fs-12 font-weight-400 d-flex justify-content-end align-items-center" style="padding-right: 40px;">
                @if (!element?.oldContinueWithQr) {
                  <button class="v-btn btn open-report-button cursor-pointer" (click)="openReport(element)">{{ 'MAIN.CONTENT.REPORT-LIST.LIST.VIEW' | translate }}</button>
                }
                @if (element?.oldContinueWithQr) {
                  <div dropdown class="btn-group dropdown-wrapper-list"
                    style="width: 120px;">
                    <button id="workflow-actions-dropdown-toggle-button" dropdownToggle #workflowActionsToggleBtn
                      type="button" class="btn btn-primary action-dropdown action-dropdown-show-options p-0"
                    style="border-color: white !important;width: 70%;">{{ 'MAIN.CONTENT.REPORT-LIST.OPTIONS' | translate }}</button>
                    <button id="workflow-actions-dropdown-split-button" type="button"
                      class="btn btn-danger dropdown-toggle dropdown-toggle-split "
                      style="border-color: white !important;"
                      (click)="$event.stopPropagation(); workflowActionsToggleBtn.click()"
                      aria-controls="workflow-actions-dropdown">
                    </button>
                    <ul id="workflow-actions-dropdown" *dropdownMenu class="dropdown-menu" aria-labelledby="workflow-actions-dropdown-toggle-button">
                      <li role="menuitem">
                        <a class="dropdown-item" (click)="openReport(element)">{{ 'MAIN.CONTENT.DASHBOARD.WORKFLOW-TABLE.ACTIONS.SUBMITTED-OPTIONS.SHOW-REPORT' | translate }}</a>
                      </li>
                      @if (element?.oldContinueWithQr) {
                        <li role="menuitem">
                          <a class="dropdown-item" (click)="changeToPrefilled(element)">{{ 'MAIN.CONTENT.DASHBOARD.WORKFLOW-TABLE.ACTIONS.SUBMITTED-OPTIONS.CHANGE-PREFILLED' | translate }}</a>
                        </li>
                      }
                    </ul>
                  </div>
                }
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <div>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </div>
          </table>
        </div>
        <mat-paginator
          [pageSizeOptions]="[25, 50, 100]"
          [pageSize]="25"
          showFirstLastButtons
          aria-label="Select page of reports">
        </mat-paginator>
      </div>
    }

    <div [hidden]="tabIndex != 1">
      @if (sessionListLoaded) {
        <app-session-list></app-session-list>
      }
    </div>


  </div>

  @if (showCountPanel) {
    <div class="card user-information">
      <div class="card-body info">
        <div class="d-flex align-items-center" style="position: absolute;right: 0;bottom: 0;left: 0;top: 0;z-index: 3;">
          <img src="assets/img/warning_copy.svg" alt="" class="ms-4 me-2">
          <label class="fs-14 font-weight-500 me-4 text-white">{{ 'MAIN.USER-WORKFLOW.LICENCE-LIMIT' | translate }}</label>
          <!-- <button class="v-btn btn btn-primary-outline" style="color: white;border-color: white;" >{{ 'MAIN.CONTENT.USER-LIST.DEACTIVATE.CANCEL' | translate }}</button> -->
        </div>
      </div>
    </div>
  }
</div>

<ng-template #loading>
  <div class="loader">
    <div class="spinner"></div>
  </div>

</ng-template>